var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsgSmallBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 339 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.699 0.85087L338.515 0.850098V35.5515L252.699 35.5523C231.05 35.5523 210.953 46.7888 199.615 65.2314L165.297 121.059C162.797 125.125 160.024 128.966 157.009 132.565L252.517 132.565C252.577 132.564 252.637 132.564 252.697 132.564L337.812 132.564V167.266L252.697 167.266C252.649 167.266 252.601 167.266 252.553 167.266C230.959 167.316 210.926 178.543 199.614 196.945L165.295 252.772C147.644 281.485 116.354 298.979 82.6493 298.979H0.0927734L0.092775 264.278H82.6493C104.298 264.278 124.395 253.042 135.733 234.599L170.051 178.772C172.551 174.706 175.324 170.865 178.339 167.266L0.0996823 167.266V167.265H0.0940763L0.0940778 132.565H55.0761H82.6511C82.6785 132.565 82.7058 132.565 82.7331 132.565C104.351 132.537 124.411 121.305 135.734 102.886L170.053 47.0585C187.704 18.345 218.994 0.850866 252.699 0.85087Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsgSmallBlack);
export default __webpack_public_path__ + "static/media/Esg-Small-Black.20b448a8474109eb4d52d5043fdfa82e.svg";
export { ForwardRef as ReactComponent };